import { AsyncPipe, NgIf } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { TranslateModule } from "@ngx-translate/core";
import { UserMenuModule } from "../user-menu/user-menu.module";
import { NavbarComponent } from "./navbar.component";
import { NiceNavigationModule } from "@recursyve/nice-ui-kit.v2";

@NgModule({
    imports: [NiceNavigationModule, UserMenuModule, MatButtonModule, MatIconModule, AsyncPipe, TranslateModule, NgIf],
    declarations: [NavbarComponent],
    exports: [NavbarComponent]
})
export class NavbarModule {}
